import {remFromPx} from "../../../services/utils/ui-commons";
import React from "react";
import * as ReactDOM from "react-dom";

export class AutoCompleteList extends React.Component {

    componentDidUpdate(prevProps) {
        if (this.scrolledSelection!==this.selection) {

            this.scrolledSelection=this.selection;

            if (this.containerDOMRef!==undefined) {
                const scrollTop = this.containerDOMRef.current.scrollTop;
                const clientHeight = this.containerDOMRef.current.clientHeight;

                if (this.selection !== undefined) {
                    const domRef = this.lineDomRef[this.selection];
                    if (domRef !== undefined) {
                        const domNode = ReactDOM.findDOMNode(domRef.current);
                        const offsetTop = domNode.offsetTop;
                        if (offsetTop > (scrollTop + clientHeight)) {
                            domNode.scrollIntoView(false);
                        } else {
                            if (offsetTop < scrollTop) {
                                domNode.scrollIntoView(true);
                            }
                        }
                    }
                }
            }
        }
    }

    constructor(props) {
        super(props);
        this.selection=undefined;
        this.scrolledSelection=undefined;
    }

    render() {

        this.lineDomRef = [];
        if (!this.props.helperVisible) {
            return '';
        }

        const displayProps = this.props.displayProps;
        const valueProps = this.props.valueProps;

        const {maxOptions, offsetX, offsetY} = displayProps;
        const {inputValue, left, matchStart, matchLength,options, selection, top} = valueProps;


        this.selection=selection;

        if (options.length === 0) {
            return '';
        }

        if (selection >= options.length) {
            return '';
        }

        const value = inputValue ? inputValue : '';

        const optionNumber = displayProps.maxOptions === 0 ? options.length : maxOptions;

        const valueNoAccent = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        const helperOptions = options.slice(0, optionNumber).map((option, idx) => {
            const valNoAccent = option.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            const highlightStart = valNoAccent.toLowerCase().indexOf(valueNoAccent.substr(matchStart, matchLength).toLowerCase());
            const domRef = React.createRef();
            this.lineDomRef.push(domRef);


            const separatorStyle = {
                width:'100%',
                paddingTop:remFromPx(15),
                marginBottom:remFromPx(5),
               // borderBottom:'1px solid #002538',
            };

            const liStyle = {
                cursor: 'pointer',
                minWidth: remFromPx(100),

            };

            const lineStyle = {
                padding: remFromPx(10),
        };

            return (
                <li
                    ref={domRef}
                    style={liStyle}
                    key={option.key}
                    onClick={() => {
                        this.props.onClickLine(idx);
                    }}
                    onMouseEnter={() => {
                        this.props.onEnterLine(idx);
                    }}
                >
                    <div className={idx === selection ? 'active' : null} style={lineStyle}>
                        {option.value.slice(0, highlightStart)}
                        <strong>{option.value.substr(highlightStart, matchLength)}</strong>
                        {option.value.slice(highlightStart + matchLength)}
                    </div>
                    {
                        option.separator ? <div style={separatorStyle}/> : ''
                    }
                </li>
             );
        });

        const style = {
            left: left + offsetX,
            top: top + offsetY,
            fontSize: remFromPx(14),
            maxHeight: remFromPx(400),
            overflowY: 'scroll'
        };

        this.containerDOMRef = React.createRef();
        return (
            <ul ref={this.containerDOMRef} className="react-autocomplete-input" style={style}>{helperOptions}</ul>
        );
    }
}
